import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from "react";
import { getOS } from "../logic";
/**
 * Hook to detect the user's operating system.
 * Uses the modern User-Agent Client Hints API (navigator.userAgentData).
 *
 * @returns The detected operating system: "mac" | "windows" | "linux" | "unknown"
 *
 * @example
 * const os = useOS();
 * const modifierKey = os === "mac" ? "⌘" : "Ctrl";
 */
var useOS = function useOS() {
  var _useState = useState("unknown"),
    _useState2 = _slicedToArray(_useState, 2),
    os = _useState2[0],
    setOS = _useState2[1];
  useEffect(function () {
    setOS(getOS());
  }, []);
  return os;
};
export default useOS;